/**
 * Tokens de marca para estilos en línea (BRAND.md).
 *
 * El sistema visual vive en `tailwind.config.js` y ahí manda: `bg-vd-naranja`,
 * `text-vd-h2`, `shadow-warm`, `rounded-card`. Este archivo NO es una segunda
 * fuente de verdad, es el mismo valor expuesto para las pantallas construidas
 * con `style={{ ... }}` en vez de clases — hoy el landing, que son mil líneas
 * de estilos en línea y reescribirlas a Tailwind sería otra tarea, con su
 * propio riesgo de regresión.
 *
 * La alternativa era dejar los hex sueltos donde estaban. Eso es exactamente
 * cómo aparecieron las cinco copias de la flip card: cada pantalla con su
 * propio `#FF5252` ligeramente distinto, y nadie sabiendo cuál era el bueno.
 *
 * Si tocas un valor aquí, tócalo también en `tailwind.config.js`. Son dos
 * ventanas al mismo manual.
 */

/** Paleta (BRAND.md §1). */
export const VD = {
  naranja: '#FA4D0A',
  coral: '#F73E48',
  rojoVivo: '#FF1F1F',

  tinta: '#0E0E10',
  grafito: '#33333A',
  pizarra: '#6E6E77',
  niebla: '#F5F5F7',
  linea: '#E7E7EC',
  blanco: '#FFFFFF',

  rosa: '#F794B4',
  lavanda: '#97B0F5',
  ambar: '#FBA63C',
  marino: '#2C3350',
  exito: '#1A9C52',
  alerta: '#E23434',
};

/** Los tres degradados del manual. Ángulo de marca: 100°. */
export const GRAD = {
  marca: 'linear-gradient(100deg, #FA4D0A, #F73E48)',
  vivo: 'linear-gradient(100deg, #FA4D0A, #FF1F1F)',
  rojoRosa: 'linear-gradient(100deg, #F52B16, #FA759F)',
};

/**
 * Sombras cálidas (BRAND.md §4: «cálidas y suaves; nunca duras ni grises»).
 * Todas salen del naranja de marca, no de negro con opacidad.
 */
export const SOMBRA = {
  sm: '0 2px 8px -2px rgba(250, 77, 10, 0.18)',
  md: '0 10px 24px -8px rgba(250, 77, 10, 0.28)',
  lg: '0 18px 40px -12px rgba(250, 77, 10, 0.35)',
  xl: '0 28px 64px -16px rgba(250, 77, 10, 0.40)',
};

/** Radios (BRAND.md §4). Los chips y botones van pill. */
export const RADIO = {
  card: 24,
  input: 11,
  pill: 9999,
};

/**
 * Texto pintado con un degradado. Es el recurso que el manual usa para la cifra
 * de ahorro y para los titulares que cargan la promesa.
 */
export const textoDegradado = (gradiente = GRAD.marca) => ({
  backgroundImage: gradiente,
  WebkitBackgroundClip: 'text',
  backgroundClip: 'text',
  color: 'transparent',
});
